interface INavButton {
  href: string;
  btnText: string;
  isScrolled?: boolean;
}

const NavButton = ({ href, btnText, isScrolled }: INavButton) => {
  // rendering navbar button component here
  return (
    <li className="group relative">
      <a
        href={href}
        className={`font-marcellus ${isScrolled ? "text-legal-dark-blue" : "text-legal-white"} duration-300 hover:opacity-70`}
      >
        {btnText}
      </a>
      <div className="absolute hidden h-[2px] w-0 bg-legal-brown duration-300 ease-in-out group-hover:w-full md:block"></div>
    </li>
  );
};

export default NavButton;
